<div *ngIf="isInProgress">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">IDF Report</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <div class="row mr-1">
      <div class="col-md-10">
        <form [formGroup]="form" (ngSubmit)="filter()" class="form-inline">
          <div class="form-group">
              <label>From:<span style="color:red;">*</span></label>&nbsp;&nbsp;
              <input type="date" formControlName="date_from" class="form-control" placeholder="Date From" value="">
              <span *ngIf="submitted && form.get('date_from')?.hasError('required')" style="color:red"> <strong>Please enter or select starting date!</strong></span>
          </div>
          &nbsp;&nbsp;&nbsp;
          <div class="form-group">
              <label>To:<span style="color:red;">*</span></label>&nbsp;&nbsp;
              <input type="date" formControlName="date_to" class="form-control" placeholder="Date To" value="">
              <span *ngIf="submitted && form.get('date_to')?.hasError('required')" style="color:red"> <strong>Please enter or select ending date!</strong></span>
          </div>
          &nbsp;&nbsp;&nbsp;
          <label>Consignee:</label>&nbsp;
          <select formControlName="consignee_id"  class="form-control">
              <option value="">All</option>
              <option [value]="consignee.id" *ngFor="let consignee of consignees">{{ consignee.consignee_name }}</option>
          </select>
          &nbsp;&nbsp;&nbsp;
          <label>Agent:</label>&nbsp;
          <select formControlName="agent_id" class="form-control">
            <option value="">All</option>
            <option [value]="agent.id" *ngFor="let agent of agents">{{ agent.company_name }}</option>
          </select>
          &nbsp;&nbsp;&nbsp;
          <div class="form-group">
              <button type="submit" class="btn btn-outline-success"><i class="fas fa-filter" aria-hidden="true">&nbsp;</i>Filter</button>
          </div>
        </form>
      </div>
      <div class="col-md-1">
        <div class="row">
          <button type="submit" class="btn btn-success btn-sm" (click)="exportToPdf()"><i class="fa fa-file-pdf" aria-hidden="true">&nbsp;</i>Export to PDF</button>
        </div>
      </div>
      <div class="col-md-1">
        <div class="row">
          <button type="submit" class="btn btn-success btn-sm" (click)="exportToExcel()"><i class="fa fa-file-excel" aria-hidden="true">&nbsp;</i>Export to Excel</button>
        </div>
      </div>
    </div>
  </section>
      <!-- /.content-header -->
  <section class="content">
    <div class="container-fluid" id="pspdfkit-container" style="width: 100%; height: 100vh">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title text-center w-100"><b>IDF Report for the period from {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }} </b></h3>
        </div>
        <!-- /.card-header -->
        <div class="card-body" style="overflow-x: auto; overflow-y: auto; white-space: nowrap; height: 850px;">
          <!--Error messages here-->
          <table id="idfTable" class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                  <th>Date</th>
                  <th>BL NO.</th>
                  <th>Consignee</th>
                  <th>Agent</th>
                  <th>Chassis No.</th>
                  <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of idf_data">
                <td>{{row.date_posted | date: 'dd-MM-yyyy'}}</td>
                <td>{{row.bl_no}}</td>
                <td>{{row.consignee_name}}</td>
                <td>{{row.agent_name}}</td>
                <td>{{row.chassis_no}}</td>
                <td>{{row.amount | number}}</td>
              </tr>
              <tr>
                <td colspan="5"><b>Total</b></td>
                <td><b>{{ total | number }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.card-body -->
      </div>
    </div>
  </section>
